import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-pagenotfound',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pagenotfound.component.html',
  styleUrls: []
})
export class PagenotfoundComponent implements OnInit {
  videourl = "assets/pagenotfound.mp4"
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.videourl = "assets/pagenotfound.mp4"
  }

}
